import UIComponent from "../../ui/component";
import { PaymentSuccessBlock } from "./widget-block/PaymentSuccessBlock";
import { PaymentErrorBlock } from "./widget-block/PaymentErrorBlock";
import { GTrigger} from "../../ui/components/index.js";
import goals from "../../utils/goals.js";

export class PaymentWidget extends UIComponent {
    initialized = false;
    paymentData = null;
    paymentCompleted = false;
    scriptGlobalVar = null;
    successBlock = null;
    content = null;
    iframe = null;

    init() {
        try {
            const successModalElement = document.querySelector(
                "#PaymentSuccessBlock"
            );
            const errorModalElement =
                document.querySelector("#PaymentErrorBlock");
            this.content = document.querySelector(".payment-content");

            this.successBlock = new PaymentSuccessBlock(successModalElement);
            this.errorBlock = new PaymentErrorBlock(errorModalElement);

            this.successBlock.init();
            this.errorBlock.init();

            this.paymentData = this.dataJson("payment-data");

            if (this.paymentData) this.show();
        } catch (error) {
            console.error(`PaymentWidget initialization error:`, error);
            this.error({ error: "Initialization failed" });
        }
    }

    show() {
        this.setLoadingState(true);
        this.empty();
        console.log(this.paymentData.links);
    }

    setLoadingState(isLoading) {
        const btn = this.find("#customPayButton");
        const btnText = this.find("#customButtonText");

        // Кнопку прячем только на время запроса, иначе после неуспешной попытки
        // повторить оплату уже нечем
        if (btn) btn.style.display = isLoading ? "none" : "block";
        if (btnText) btnText.style.display = isLoading ? "none" : "block";
    }

    showError(msg) {
        if (this.errorBlock) {
            this.errorBlock.handlePaymentError({
                title: "Ошибка платежа",
                message: msg,
                retryUrl: window.location.href,
            });
        } else {
            const el = this.find("#customPaymentMessage");
            if (el) {
                el.textContent = msg;
                el.style.display = "block";
            }
        }
    }

    error({ error }) {
        this.showError(`Произошла ошибка: ${error} `);
        this.content.style.display = "none";
        goals.reach('paymentCancelled')
    }

    success(data) {
        try {
            if (this.successBlock) {
                const links =
                    this.paymentData && this.paymentData.links
                        ? this.paymentData.links
                        : data.links;

                console.log(this.external, this)
                if(Number(this.external)) {
                    const params = new URLSearchParams(window.location.search);
                    const returnUrl = params.get("return");
                    goals.reach('paymentSuccess')
                    window.location.href = returnUrl;
                    return;
                }

                this.successBlock.handlePaymentSuccess({
                    paymentId: data.id,
                    links: links,
                });
                goals.reach('paymentSuccess')
            }
        } catch (error) {
            console.error("Error handling payment success:", error);
        } finally {
            this.hidePaymentContent();
        }
    }

    loadExternalScript(url) {
        return new Promise((resolve, reject) => {
            if (window[this.scriptGlobalVar]) return resolve();
            const script = document.createElement("script");
            script.src = url;
            script.onload = resolve;
            script.onerror = () =>
                reject(new Error(`Не удалось загрузить скрипт: ${url}`));
            document.head.appendChild(script);
        });
    }

    hidePaymentContent() {
        if (this.content) {
            this.content.style.display = "none";
        }
    }
}
